import React from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Text } from 'elements';
import { makeComma } from 'libs/utils';
import { TCasePrice } from 'modules/case/types';
import { CWindowWidth, CRefundInformation } from 'constants/base.const';
import { Button } from 'antd';
import { Colors, SecondaryColor } from 'GlobalStyles';

type TPurchase = {
  id: Number;
  price: TCasePrice;
  season?: string;
  isPayed?: boolean;
};

const Purchase = ({ id, price, season, isPayed }: TPurchase) => {
  const history = useHistory();
  const packagePrice = 450000;
  return (
    <Grid padding='25px 0' backgroundColor={Colors.background} justify='center'>
      <Grid maxWidth={`${CWindowWidth}px`} sm={{ justify: 'center' }}>
        <Grid justify='center' sm={{ width: '220px' }}>
          <Text size='2rem' sm={{ size: '1.4rem' }}>
            Career Step 해설은 구매 후 이용이 가능합니다.
            <Text size='1rem' color={Colors.grey2} margin='0 10px' sm={{ size: '0.6rem' }}>
              * 구매 후 1년간 이용 가능
            </Text>
            <a target='_blank' rel='noopener noreferrer' href={CRefundInformation}>
              <Text size='1rem' textDecoration='underline' color={Colors.grey2}>
                환불규정
              </Text>
            </a>
          </Text>
        </Grid>

        <Grid justify='center' gap='5%' marginTop='25px'>
          <Grid
            isInline
            width='40%'
            maxWidth='300px'
            backgroundColor={Colors.white}
            padding='16px 32px'
            sm={{ width: '100%', padding: '16px' }}
          >
            <Grid justify='center'>
              <Text size='1.2rem' bold>
                {price.careerstep_name ? price.careerstep_name.split('.')[0] : '-'} 해설 구매하기
              </Text>
            </Grid>
            <Grid justify='center' align='center' gap='5px' marginTop='4px'>
              {/* <Text>{price.careerstep_name? price.careerstep_name.split(".")[0]: '-'}</Text>
              <Text color={SecondaryColor} bold>{price.careerstep_answer?.length ?? '-'}건</Text> */}
              <Text>Case 1개의 모든 공식 해설 포함</Text>
            </Grid>
            <Grid justify='center' marginTop='12px'>
              {/* <Grid isInline width='77px' /> */}
              {/* 기존 cs 표기 */}
              {/* <Text color={SecondaryColor} size='1.2rem'>{price.careerstep_credit ?? '-'} CS</Text> */}
              {/* <Text size='0.8rem' color={Colors.grey2} padding='3px 0'>*1 CS = {makeComma(price.CS)}원</Text> */}
              {/* 수정 원으로 표기 */}

              {isPayed &&
              (price.season_package_amount === packagePrice || price.season_package_amount === 0) ? (
                //이미 구매한 상품인데 할인 문구 안들어갔을 때
                <Text color={SecondaryColor} size='1.2rem'>
                  이미 구매한 상품입니다.
                </Text>
              ) : isPayed &&
                price.season_package_amount !== packagePrice &&
                price.season_package_amount !== 0 ? (
                //이미 구매한 상품인데 할인문구 들어갔을 때
                <Grid flexDirection='column' align='center'>
                  <Text color={Colors.grey2} size='1rem'>
                    ㅤㅤㅤㅤㅤ{' '}
                  </Text>
                  <Text color={SecondaryColor} size='1.2rem'>
                    이미 구매한 상품입니다.
                  </Text>
                  <Text color={Colors.grey2} size='0.9rem'>
                    ㅤㅤㅤㅤ
                  </Text>
                </Grid>
              ) : price.season_package_amount !== packagePrice && price.season_package_amount !== 0 ? (
                //구매한 상품이 아닌데 패키지에 할인이 들어갔을 때(스타일링 맞춰주기위해)
                <Grid flexDirection='column' align='center'>
                  <Text color={Colors.grey2} size='1rem'>
                    ㅤㅤㅤㅤㅤ{' '}
                  </Text>
                  <Text color={SecondaryColor} size='1.2rem'>
                    {price.careerstep_amount ? makeComma(price.careerstep_amount) : '-'} 원
                  </Text>
                  <Text color={Colors.grey2} size='0.9rem'>
                    ㅤㅤㅤㅤ
                  </Text>
                </Grid>
              ) : (
                //구매한 상품이 아닌데 패키지 상품에도 가격할인 문구가 없을 때
                <Text color={SecondaryColor} size='1.2rem'>
                  {price.careerstep_amount ? makeComma(price.careerstep_amount) : '-'} 원
                </Text>
              )}
            </Grid>
            {isPayed ? (
              <Grid justify='center' marginTop='10px'>
                <Button
                  disabled
                  type='primary'
                  size='large'
                  className='secondary'
                  style={{ width: 130 }}
                  onClick={() => history.push(`/purchase/case?id=${id}&p_type=single&season=${season}`)}
                >
                  <Text color={Colors.white} size='1rem'>
                    구매하기
                  </Text>
                </Button>
              </Grid>
            ) : (
              <Grid justify='center' marginTop='10px'>
                <Button
                  type='primary'
                  size='large'
                  className='secondary'
                  style={{ width: 130 }}
                  onClick={() => history.push(`/purchase/case?id=${id}&p_type=single&season=${season}`)}
                >
                  <Text color={Colors.white} size='1rem'>
                    구매하기
                  </Text>
                </Button>
              </Grid>
            )}
          </Grid>

          <Grid
            isInline
            width='40%'
            maxWidth='300px'
            backgroundColor={Colors.white}
            padding='16px 32px'
            sm={{ width: '100%', marginTop: '20px', padding: '16px' }}
          >
            <Grid justify='center'>
              <Text size='1.2rem' bold>
                전체 Case 해설 구매하기
              </Text>
            </Grid>
            <Grid justify='center' align='center' gap='5px' marginTop='4px'>
              {/* <Text>시즌 Case {price.season_case_count ?? '-'}개의 모든 공식 해설</Text>
              <Text color={SecondaryColor} bold>{price.season_package_answer?.length ?? '-'}건</Text> */}
              <Text>Case 10개의 모든 공식 해설 포함</Text>
            </Grid>
            <Grid justify='center' align='flex-end' gap='10px' marginTop='12px'>
              {/* <Grid isInline width='77px' /> */}
              {/* 기존 cs 표기 */}
              {/* <Text color={SecondaryColor} size='1.2rem'>{price.season_package_credit ?? '-'} CS</Text> */}
              {/* <Text size='0.8rem' color={Colors.grey2} padding='3px 0'>*1 CS = {makeComma(price.CS)}원</Text> */}
              {/* 수정 원으로 표기 */}
              {price.season_package_amount === packagePrice ? (
                //상품 아무것도 사지 않았을 때
                <Text color={SecondaryColor} size='1.2rem'>
                  {price.season_package_amount ? makeComma(price.season_package_amount) : '-'} 원
                </Text>
              ) : price.season_package_amount === 0 ? (
                //상품을 모두 샀을 때
                <Text color={SecondaryColor} size='1.2rem'>
                  이미 구매한 상품입니다
                </Text>
              ) : (
                //상품을 개별적으로 샀을 때 할인 문구 삽입
                <Grid flexDirection='column' align='center'>
                  <Text color={Colors.grey2} size='1rem' textDecoration='line-through'>
                    {' '}
                    정가 450,000 원
                  </Text>
                  <Text color={SecondaryColor} size='1.2rem'>
                    할인가 {price.season_package_amount ? makeComma(price.season_package_amount) : '0'} 원
                  </Text>
                  <Text color={Colors.grey2} size='0.9rem'>
                    (이미 구매한 case 1건당 45,000원 차감)
                  </Text>
                </Grid>
              )}

              {/* <Text color={SecondaryColor} size='1.2rem'>{price.season_package_amount? makeComma(price.season_package_amount) : '-'} 원</Text> */}
            </Grid>
            {price.season_package_amount === 0 ? (
              <Grid justify='center' marginTop='10px'>
                <Button
                  disabled
                  type='primary'
                  size='large'
                  className='secondary'
                  style={{ width: 130 }}
                  onClick={() => history.push(`/purchase/case?id=${id}&p_type=package&season=${season}`)}
                >
                  <Text color={Colors.white} size='1rem'>
                    구매하기
                  </Text>
                </Button>
              </Grid>
            ) : (
              <Grid justify='center' marginTop='10px'>
                <Button
                  type='primary'
                  size='large'
                  className='secondary'
                  style={{ width: 130 }}
                  onClick={() => history.push(`/purchase/case?id=${id}&p_type=package&season=${season}`)}
                >
                  <Text color={Colors.white} size='1rem'>
                    구매하기
                  </Text>
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Purchase;
